export default "__VITE_ASSET__B8o15iIH__"